export default {
  init() {
    // Import all SVG files from the icons directory
    // This will be processed at build time to generate the sprite
    const svgContext = require.context('!svg-sprite-loader!../../icons/svg', false, /\.svg$/);
    svgContext.keys().forEach(key => {
      svgContext(key);
    });
  },
};
